import { useState } from 'react';
import { faqItems } from '@/mocks/faqData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于福利导航，您想了解的都在这
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="font-heading text-base text-foreground-800 pr-4">
                  {faq.question}
                </h3>
                <div
                  className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-all ${
                    openIndex === index
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200 pt-4">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}